/* SAML NameId format constants*/
export const UNSPECIFIED = "UNSPECIFIED";
export const PERSISTENT = "PERSISTENT";
export const TRANSIENT = "TRANSIENT";
export const EMAIL_ADDRESS = "EMAIL_ADDRESS";
export const WINDOWS_DOMAIN_QUALIFIED_NAME = "WINDOWS_DOMAIN_QUALIFIED_NAME"

/* Unspecified NameId format attributes*/
export const UNSPECIFIED_NAME_ID_EMAIL_ADDRESS = "EMAIL";
export const UNSPECIFIED_NAME_ID_USER_PRINCIPAL_NAME = "USER_PRINCIPAL_NAME";
export const UNSPECIFIED_NAME_ID_USER_DISPLAY_NAME = "USER_DISPLAY_NAME";
export const UNSPECIFIED_NAME_ID_OBJECT_GUID = "OBJECT_GUID";
export const UNSPECIFIED_NAME_ID_OBJECT_SID = "OBJECT_SID";

/* User Attributes constants*/
export const USER_ID = "USER_ID";
export const OBJECT_SID = "OBJECT_SID";
export const OBJECT_GUID = "OBJECT_GUID";
export const FIRST_NAME = "FIRST_NAME";
export const LAST_NAME = "LAST_NAME";
export const EMAIL = "EMAIL";
export const DOMAIN = "DOMAIN";
export const USER_PRINCIPAL_NAME = "USER_PRINCIPAL_NAME";
export const USER_DISPLAY_NAME = "USER_DISPLAY_NAME";
export const CUSTOM_ATTRIBUTE = "CUSTOM_ATTRIBUTE";
export const NET_BIOS_SAM_ACCOUNT_NAME = "NET_BIOS_SAM_ACCOUNT_NAME";
export const NON_LDAP_EPIC_USERNAME = "NON_LDAP_EPIC_USERNAME";
export const EXTENDED_ATTRIBUTE = "EXTENDED_ATTRIBUTE";
export const REGULAR_USER_ATTRIBUTES = [USER_ID, OBJECT_SID, OBJECT_GUID, FIRST_NAME,
  LAST_NAME, EMAIL, DOMAIN, USER_PRINCIPAL_NAME, USER_DISPLAY_NAME, CUSTOM_ATTRIBUTE,
  NET_BIOS_SAM_ACCOUNT_NAME, NON_LDAP_EPIC_USERNAME]

/* User Group Attributes constants*/
export const START_WITH = "START_WITH";
export const CONTAIN = "CONTAIN";
export const EQUALS = "EQUALS";

/* SAML metadata constants*/
export const PUBLIC_KEY_CERTIFICATE_INFO = "publicKeyCertificateInfo";
export const SLO_ITEMS = "SloItems";
export const ACS_ITEMS = "AcsItems";
export const NAME_ID_FORMAT = "samlNameIdFormatEnum";

/* Selected metadata import mode*/
export const IMPORT_FROM_FILE = "IMPORT_FROM_FILE";
export const IMPORT_FROM_URL = "IMPORT_FROM_URL";

/* default User Attributes constant*/
export const DEFAULT_USER_ATTRIBUTES = [
  {
    "idpUserAttributeEnum": FIRST_NAME,
    "userAttributeName": "firstName",
    "userSpecifiedValue": ""
  },
  {
    "idpUserAttributeEnum": LAST_NAME,
    "userAttributeName": "lastName",
    "userSpecifiedValue": ""
  },
  {
    "idpUserAttributeEnum": EMAIL,
    "userAttributeName": "email",
    "userSpecifiedValue": ""
  }
];
